/**
 * A entidade ativa, do shell para as páginas.
 *
 * Um contexto em vez de prop pelo roteador porque o dono do estado é o CABEÇALHO
 * (DS-40): existe UM seletor em todo o sistema, e nenhuma página o duplica. A
 * página só precisa saber qual é a entidade — e recarregar quando ela mudar.
 *
 * O cliente HTTP recebe a mesma informação por outro caminho
 * (`definirEntidadeDoContexto`), porque o cabeçalho `X-DV-Entity` vai em todo
 * pedido e nenhuma tela deve lembrar disso.
 */
import { createContext, useContext } from 'react'

export const ContextoDeEntidade = createContext<string | null>(null)

/**
 * O AMBIENTE da entidade ativa, num contexto PRÓPRIO.
 *
 * Separado do id de propósito. O id é o que faz as vinte e oito telas recarregarem, e
 * `useEntidadeAtiva()` devolve exatamente ele em todas elas; o ambiente interessa a uma
 * só — a Visão Geral acende a nota de consolidação quando a entidade ativa é um GRUPO
 * (spec 1.2 §Comportamentos · DS-09/DS-40). Trocar o valor do contexto por um objeto
 * obrigaria as outras vinte e sete a mudar sem ganhar nada com isso.
 */
export type AmbienteDaEntidadeAtiva = 'producao' | 'sandbox' | 'consolidado'

export const ContextoDoAmbiente = createContext<AmbienteDaEntidadeAtiva | null>(null)

export function useEntidadeAtiva(): string | null {
  return useContext(ContextoDeEntidade)
}

export function useAmbienteDaEntidade(): AmbienteDaEntidadeAtiva | null {
  return useContext(ContextoDoAmbiente)
}
